import { render, staticRenderFns } from "./SignificantGap.vue?vue&type=template&id=147b5870&scoped=true&"
import script from "./SignificantGap.vue?vue&type=script&lang=js&"
export * from "./SignificantGap.vue?vue&type=script&lang=js&"
import style0 from "./SignificantGap.vue?vue&type=style&index=0&id=147b5870&lang=scss&scoped=true&"
import style1 from "./SignificantGap.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b5870",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VIcon,VItem,VItemGroup,VRow,VSelect,VSimpleTable})
